import React, { useRef } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { Button } from 'apps/auth/components/common/Button/Button';
import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';
import { FixedBottomPanel } from 'apps/auth/components/common/Layout/FixedBottomPanel/FixedBottomPanel';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { IconWrapper } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { EUR, GB, GBP } from 'apps/auth/constants/GaConstants';

import TcPopup from '../popups/TcPopup';

const ContentWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-grow: 1;
`;

const ListAddAccounts = (props) => {
    const popupRef = useRef(null);

    const onClickHandler = (e) => {
        e.preventDefault();
        popupRef.current?.open(<TcPopup popupRef={popupRef} />);
    };

    const isGBCountry = props.countryCode === GB;
    const subHeader = isGBCountry ? props.subHeaderOpenUK : props.subHeaderOpenOtherCountries;

    const renderAccounts = (arrayAccounts) => {
        if (arrayAccounts?.length > 0) {
            let sortArray;
            const [gbpAccount] = arrayAccounts.filter((account) => account.pocketCurrency.code === GBP);
            const [euroAccount] = arrayAccounts.filter((account) => account.pocketCurrency.code === EUR);
            const restAccounts = arrayAccounts.filter((account) => account.pocketCurrency.code !== GBP && account.pocketCurrency.code !== EUR);
            if (isGBCountry) {
                sortArray = [gbpAccount, euroAccount, ...restAccounts];
            } else {
                sortArray = [euroAccount, gbpAccount, ...restAccounts];
            }
            return sortArray.map((account, index) => {
                const { currencyIcon, pocketCurrency } = account;
                const isGBPCountry = pocketCurrency.code === GBP;
                return (
                    <Row type="listItem" key={`${index}${pocketCurrency.title}`} indent="adaptive-24-32">
                        <Panel isBordered hasBorderRadius isHoverable>
                            <IconWrapper>
                                <FlagIcon name={currencyIcon} size="small" />
                            </IconWrapper>
                            <ContentWrapper>
                                <Row flex direction="column">
                                    {pocketCurrency.title}
                                    {isGBPCountry && (
                                        <Text color="secondary" size="secondary">
                                            {props.textBritishAccounts}
                                        </Text>
                                    )}
                                </Row>
                                <Text color="secondary" smallCaps>
                                    {pocketCurrency.code}
                                </Text>
                            </ContentWrapper>
                        </Panel>
                    </Row>
                );
            });
        } else {
            return null;
        }
    };
    return (
        <>
            <ModalComponent>
                <HeaderPanel title={props.headerOpen} subtitle={subHeader} />
                <ul>{renderAccounts(props.gaAccounts)}</ul>
                <FixedBottomPanel>
                    <Button type="button" onClick={onClickHandler} raised={true} size="fit" caption={props.getAccounts} />
                </FixedBottomPanel>
            </ModalComponent>
            <PopupNew ref={popupRef} />
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        getAccounts: state.messages.pageMessages.getAccounts,
        countryCode: state.extra.country_code,
        headerOpen: state.messages.pageMessages.headerOpen,
        subHeaderOpenUK: state.messages.pageMessages.subHeaderOpenUK,
        subHeaderOpenOtherCountries: state.messages.pageMessages.subHeaderOpenOtherCountries,
        gaAccounts: state.extra.gaAccounts,
        textBritishAccounts: state.messages.pageMessages.textBritishAccounts,
    };
};
ListAddAccounts.propTypes = {
    getAccounts: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    headerOpen: PropTypes.string.isRequired,
    subHeaderOpenUK: PropTypes.string.isRequired,
    subHeaderOpenOtherCountries: PropTypes.string.isRequired,
    gaAccounts: PropTypes.array,
    textBritishAccounts: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(ListAddAccounts);
